module.exports = __webpack_public_path__ + "static/media/Avenir-Light.57a74099.woff";